var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 908,
    viewBox: "0 0 767 908",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 767,
    height: 908,
    fill: "#191D21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_7983)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.527 68.1414C478.373 73.9353 466 91.9962 466 108.229V799.771C466 816.004 478.373 834.065 493.527 839.858L965.73 1020.59C980.845 1026.38 993.258 1017.86 993.258 1001.61V-93.5982C993.258 -109.841 980.845 -118.382 965.73 -112.578L493.527 68.1414ZM875.312 818.671C875.312 834.904 862.7 843.914 847.395 838.65L604.125 755.507C588.772 750.263 576.209 732.691 576.209 716.438V191.571C576.209 175.318 588.772 157.707 604.125 152.473L847.395 69.3601C862.739 64.1356 875.312 73.1461 875.312 89.339V818.671Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.335 475.832C934.335 482.245 921.055 487.499 904.833 487.499H547.526C531.314 487.499 518.034 482.245 518.034 475.832C518.034 469.418 531.314 464.154 547.526 464.154H904.833C921.055 464.154 934.335 469.408 934.335 475.832Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.169 814.386C719.509 814.386 714.066 801.06 714.066 784.817V60.1304C714.066 43.8775 719.509 30.5615 726.169 30.5615C732.829 30.5615 738.343 43.8775 738.343 60.1304V784.817C738.343 801.06 732.819 814.386 726.169 814.386Z",
    fill: "#B39D5D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_7983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 908,
    fill: "white",
    transform: "translate(466)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTablet);
export default __webpack_public_path__ + "static/media/footer-tablet.5ab5ca28e4e8f04b2bad014abdd7d8e9.svg";
export { ForwardRef as ReactComponent };